import { render, staticRenderFns } from "./c_player_registInfo.vue?vue&type=template&id=8400906e&scoped=true&"
import script from "./c_player_registInfo.vue?vue&type=script&lang=js&"
export * from "./c_player_registInfo.vue?vue&type=script&lang=js&"
import style0 from "./c_player_registInfo.vue?vue&type=style&index=0&id=8400906e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8400906e",
  null
  
)

export default component.exports